import { createContext, ReactNode, useContext, useState } from 'react';

import { Customer, CustomerInput } from '~src/model';

export type CustomerWithExtraData = Omit<Customer, 'events' | 'progress' | 'latestProgressEvent'> &
  Pick<CustomerInput, 'googleClickId' | 'utmFields' | 'scoringFields'> & {
    jyskeBankDataConsent?: boolean;
  };

export type CustomerContext = {
  customer?: Partial<CustomerWithExtraData>;
  setCustomer?: (customer?: Partial<CustomerWithExtraData>) => void;
};

const CustomerContext = createContext<CustomerContext>({});

export const CustomerContextProvider = ({ children }: { children?: ReactNode }) => {
  const [customer, setCustomer] = useState<Partial<CustomerWithExtraData>>();

  return <CustomerContext.Provider value={{ customer, setCustomer }}>{children}</CustomerContext.Provider>;
};

export const useCustomerContext = () => useContext(CustomerContext);
